import _ from "lodash";

import firebaseapp from "../firebase.js";

const firestoreDB = firebaseapp.firestore();

export default class AuthorService {
  static getAllAuthors = async () => {
    let snapshot = await firestoreDB.collection("authors").get();
    return snapshot.docs.map((doc) => doc.data());
  };
  static getAuthorByName = (authors, authorName) => {
    authorName = authorName.trim();
    let author = null;
    author = _.filter(authors, (author) => {
      return author[`name_en`] === authorName;
    });
    return author[0] ? author[0] : null;
  };
}
